const API_BASE = process.env.REACT_APP_API_URL || 'https://api.grandindigoembroidery.com';

const authHeaders = () => ({
  'Accept': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('gie_token') || ''}`,
});

// ─── Dashboard Stats ──────────────────────────────────────────────────────────

export const fetchDashboardStats = async () => {
  const res = await fetch(`${API_BASE}/dashboard/stats`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Failed to fetch stats');
  return res.json();
};

// ─── Orders ──────────────────────────────────────────────────────────────────

export const fetchOrders = async (page = 1, currency = 'USD') => {
  const res = await fetch(`${API_BASE}/dashboard/orders?page=${page}&currency=${currency}`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Failed to fetch orders');
  return res.json(); // { data: [], total, per_page, current_page, last_page }
};

/**
 * Submit a new order (multipart — may include file uploads)
 * @param {string} service
 * @param {Object} fields  – plain form fields
 * @param {File[]} files   – file attachments
 */
export const submitOrder = async (service, fields, files = []) => {
  const formData = new FormData();
  formData.append('service', service);
  Object.entries(fields).forEach(([k, v]) => {
    if (Array.isArray(v)) {
      v.forEach(item => formData.append(`${k}[]`, item));
    } else {
      formData.append(k, v ?? '');
    }
  });
  files.forEach(file => formData.append('files[]', file));

  const res = await fetch(`${API_BASE}/dashboard/orders`, {
    method: 'POST',
    headers: authHeaders(), // No Content-Type — browser sets multipart boundary automatically
    body: formData,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to submit order');
  return data;
};

// ─── Edits ────────────────────────────────────────────────────────────────────

export const fetchEdits = async (page = 1) => {
  const res = await fetch(`${API_BASE}/dashboard/edits?page=${page}`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Failed to fetch edits');
  return res.json();
};

export const submitEdit = async (orderId, instructions, files = []) => {
  const formData = new FormData();
  formData.append('order_id', orderId);
  formData.append('instructions', instructions);
  files.forEach(file => formData.append('files[]', file));

  const res = await fetch(`${API_BASE}/dashboard/edits`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to submit edit request');
  return data;
};

// ─── Profile ─────────────────────────────────────────────────────────────────

export const updateProfile = async (payload) => {
  const res = await fetch(`${API_BASE}/dashboard/profile`, {
    method: 'PUT',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to update profile');
  // Refresh stored user
  localStorage.setItem('gie_user', JSON.stringify(data.user));
  return data;
};

export const changePassword = async (payload) => {
  const res = await fetch(`${API_BASE}/dashboard/password`, {
    method: 'PUT',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to change password');
  return data;
};